import moment from "moment";
var idLocale = require("moment/locale/id");

export const formatDateTime = (date: any) => {
  if (!date) return "-";
  return moment(date).isValid()
    ? moment(date).format("YYYY-MM-DD HH:mm:ss")
    : "-";
};

export const formatDate = (date: any, format = "ymd") => {
  if (!date || date === null || date === undefined) {
    return "-";
  }

  switch (format) {
    case "ymd":
      return moment(date).format("YYYY-MM-DD");
      break;

    case "dmy":
      return moment(date).format("DD-MM-YYYY");
      break;

    case "days":
      return moment(date).format("dddd");
      break;

    case "hms":
      return moment(date).format("HH:mm:ss");
      break;

    case "hm":
      return moment(date).format("HH:mm");
      break;

    case "fromNow":
      return moment(date).fromNow();
      break;

    case "full":
      return moment(date).format("dddd, DD-MM-YYYY");
      break;

    case "ymdHHMM":
      return moment(date).format("DD-MM-YYYY HH:mm");
      break;

    case "fullDateTime":
      return moment(date).format("dddd, DD-MM-YYYY HH:mm:ss");
      break;

    default:
      return moment(date).format("YYYY-MM-DD");
      break;
  }
};

export const handleImageError = (event: any, type = "") => {
  event.currentTarget.src =
    "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg";
  // if (type === "user") event.currentTarget.src = ProfileIcon;
  event.currentTarget.className = `${event.currentTarget.className} error`;
};

export const memberCategory = (value: any) => {
  switch (value) {
    case "EMPLOYEE":
      return "EMPLOYEE";
    case "SECURITY":
      return "SECURITY";
    case "CLEANING_SERVICE":
      return "CLEANING SERVICE";
    case "OFFICE_BOY":
      return "OFFICE BOY";
    case "DRIVER":
      return "DRIVER";
    case "GARDENER":
      return "GARDENER";
    default:
      return value;
  }
};

export const notifType = (value: any) => {
  switch (value) {
    case "CREATED_USER":
      return "Pembuatan User Baru";
    case "RESET_PASSWORD":
      return "Atur Ulang Kata Sandi";
    case "NEW_COMPANY":
      return "Pembuatan Perusahaan Baru";
    default:
      return value;
  }
};

export function formatCurrency(amount: any, currency: string = "IDR"): string {
  const value = Number(amount ?? 0);

  if (isNaN(value)) return "Rp0,00";

  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(value);
}

export const insuranceCategory = (value: any) => {
  switch (value) {
    case "HEALTH":
      return "Kesehatan";
    case "WORK":
      return "Kerja";
    case "ACCIDENT":
      return "Kecelakaan";
    case "OTHERS":
      return "Lainnya";
    default:
      return value;
  }
};